var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Heart"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_135_1887",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 15
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5f6521ef73"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 0H17V14.9012H0V0Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_135_1887)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_135_1887",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 15
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "5bd1410bce"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.52931 2.89754L1.52918 2.89775C0.470591 4.64471 1.17613 6.35559 2.18033 7.32316C2.18045 7.32327 2.18057 7.32339 2.1807 7.32351L8.61627 13.5084L14.8839 7.37669C15.8288 6.31404 16.1339 5.2762 15.9484 4.12942L15.9484 4.12932C15.6872 2.51386 14.3529 1.24799 12.6957 1.06722C11.6684 0.956348 10.6971 1.24702 9.94198 1.87535L1.52931 2.89754ZM1.52931 2.89754C2.12562 1.9129 3.05349 1.26152 4.04705 1.06889M1.52931 2.89754L4.04705 1.06889M8.61968 3.44963L7.82378 2.45724C7.63549 2.22246 7.41154 2.00412 7.15347 1.80744L8.61968 3.44963ZM8.61968 3.44963L9.39606 2.4419M8.61968 3.44963L9.39606 2.4419M9.39606 2.4419C9.55483 2.23581 9.73708 2.04598 9.94178 1.87551L9.39606 2.4419ZM4.04705 1.06889C5.12862 0.861173 6.26069 1.12795 7.15312 1.80718L4.04705 1.06889Z",
    stroke: "white",
    strokeWidth: 2
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_135_1887)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0.673942 2.37951C-0.704466 4.65427 0.26676 6.86836 1.48694 8.04372L8.62247 14.9013L15.6072 8.06804C16.7421 6.80386 17.1771 5.4629 16.9356 3.96971C16.6016 1.90429 14.9026 0.30179 12.8036 0.0730572C11.5162 -0.0660407 10.2728 0.299057 9.30211 1.10686C9.04086 1.32439 8.80748 1.56733 8.60389 1.83159C8.36258 1.53072 8.07947 1.2558 7.75919 1.01176C6.64313 0.162145 5.22236 -0.175351 3.85762 0.0869943C2.56502 0.337316 1.40496 1.17245 0.673942 2.37951Z",
    stroke: "black",
    strokeWidth: 2
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/Heart.7a1b600bc94dbd17381804f21fb1a739.svg";
export { ForwardRef as ReactComponent };